import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { UserCircleGear } from '@phosphor-icons/react';

import { notify } from '../lib/notify';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ASSIGN_ROLES = ['National Sales Manager', 'Vice President', 'President'];

export const TenderOwnerPicker = ({ tender, user, onSaved }) => {
  const canAssign = ASSIGN_ROLES.includes(user?.role);
  const [tes, setTes] = useState([]);
  const [value, setValue] = useState(tender.owner_te_id || '');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!canAssign) return;
    axios.get(`${API}/tenders/tender-executives`).then((r) => setTes(r.data.items || [])).catch(() => {});
  }, [canAssign]);
  useEffect(() => { setValue(tender.owner_te_id || ''); }, [tender.owner_te_id]);

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/tenders/${tender.id}/owner`, { owner_te_id: value || null });
      onSaved?.();
    } catch (e) {
      notify(e.response?.data?.detail || 'Could not assign owner');
    } finally {
      setSaving(false);
    }
  };

  const dirty = (value || '') !== (tender.owner_te_id || '');

  return (
    <div className="flex items-center justify-between gap-2 text-sm py-0.5" data-testid="tender-owner-row">
      <span className="text-[#6D8E87] inline-flex items-center gap-1"><UserCircleGear size={14} /> Owner (TE)</span>
      {canAssign ? (
        <div className="flex items-center gap-1.5">
          <select
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="text-xs px-2 py-1 border border-[#D5E8E4] rounded bg-white max-w-[160px]"
            data-testid="tender-owner-select"
          >
            <option value="">— unassigned —</option>
            {tes.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
          </select>
          {dirty && (
            <button onClick={save} disabled={saving} className="text-xs px-2 py-1 rounded bg-[#00a69c] text-white font-semibold disabled:opacity-60" data-testid="tender-owner-save">
              {saving ? '…' : 'Save'}
            </button>
          )}
        </div>
      ) : (
        <span className="font-semibold text-[#052A23]" data-testid="tender-owner-name">{tender.owner_te_name || '— unassigned —'}</span>
      )}
    </div>
  );
};
